import { HttpResponse } from 'msw'
import { restHandlerFactory } from 'src/tests/mocks/handlerFactory'

export const updateDeliveryDateHandler = restHandlerFactory(
  '/trials/{trial_uid}/explanation_revisions/{explanation_revision_uid}/delivery_date',
  'put',
  () => {
    return HttpResponse.json(undefined, { status: 204 })
  },
)
